import { MutationTree } from 'vuex';
import { EmailGroupItem, StatisticState } from './types';

export const mutations: MutationTree<StatisticState> = {
  setEmailStatisticDetail: (state, data) => {
    state.emailStatisticDetail = data;
  },
  pushEmailStatisticDetail: (state, data) => {
    state.emailStatisticDetail = state.emailStatisticDetail.concat(data);
  },
  setEmailStatisticDetailInfo: (state, data) => {
    state.emailStatisticDetailInfo = data;
  },
  setEmailStatisticGroup: (state, data: EmailGroupItem[]) => {
    state.emailStatisticGroup = data;
  },
};